module.exports = __webpack_public_path__ + "img/twotarget.28bd124b.png";